export default __webpack_public_path__ + "static/media/Background_00254.dc0c7a31.png";